import { RouteConfig } from 'vue-router'

export const MATCH_FIELDS_PATH = '/match-fields'
export const MATCH_FIELDS_NAME = 'MatchFieldsView'

export const matchFieldsRoutesConfig: RouteConfig[] = [
  {
    path: MATCH_FIELDS_PATH,
    name: MATCH_FIELDS_NAME,
    component: () => import('@/features/matchFields/views/MatchFields.vue')
  }
]
